
export const personalData = {
  name: "Paul Charles Leroy",
  
  email: "info@idixconsulting.com",
  executiveSummary: "IDIX Consulting has a strong focus on tasks and a remarkable ability to identify patterns in data and comprehend the intricate workings of complex systems. Our independent nature, analytical thinking, critical evaluation, and creative approach extend to both our thoughts and actions. We revel in developing and executing ideas that are distinctly innovative or unconventional, showcasing our nonconformist personality. We exhibit a direct and results-oriented approach, adaptable to various situations. We favor novel solutions to traditional problems, demonstrating a talent for formulating new concepts, systems, plans, or technologies, as well as analyzing and refining existing ones. As a self-starting consultancy, our drive and sense of urgency are balanced by our commitment to accuracy and quality in our work. We maintain a holistic perspective, delegating non-core aspects that are not central to our role. Our strong technical orientation instills confidence in our professional knowledge and ability to deliver results efficiently and accurately. We take our work and responsibilities seriously, expecting the same level of dedication from our partners. Additionally, we have a knack for spotting trends in data and unraveling the complexities of intricate systems. We are a team of IT generalists, able to draw on multiple disciplines to solve a problem. We leverage our broad range of skills and experience to quickly identify the root cause of an issue and develop a solution that meets the needs of the business. Our ability to think outside the box and come up with creative solutions has made us a valuable asset to our clients.",
  citizenship: "Belgian and South African citizenship with valid passports and has indefinite leave to remain in the UK.",
  services: [
    "Customized Training Solutions: Bespoke training programs focused on practical skills in Cloud and AI technologies.",
    "Strategic Consulting: Leverage our expertise to build and scale your Cloud and AI centers of excellence. We help you identify opportunities, formulate new strategies, and refine existing systems to drive innovation and growth.",
    "Fractional CTO Services: Get the benefit of a high-level technology executive without the full-time cost. We provide strategic guidance, technical leadership, and help you navigate the complexities of your technology landscape.",
    "Engaging Delivery: Interactive, demo-heavy training, adapted to your team's needs, delivered virtually or in-person, globally.",
    "Cutting-Edge Content: Our curriculum is built on real-world consulting experience, ensuring your team learns the most current and relevant skills."
  ],
  workHistory: [
    {
      title: "Committee Lead, AI Policy, Thames Valley AI Hub (Volunteer)",
      period: "February 2025 to date",
      details: [
        "Working to provide critical thought to the current field of AI ethics and policy",
        "Working with the skills committee to ensure adequate knowledge and training is available for both school leavers (to close the skills gap) and politicians (to ensure balanced policy) and everything inbetween."
      ]
    },
    {
      title: "Chairman, Berkshire Branch of the British Computing Society (Volunteer)",
      period: "October 2023 to date",
      details: [
        "Increase community involvement in IT by way of education and STEM programs",
        "Increase awareness of the necessity for chartered status within IT",
        "Involved in working to get Continuous Professional Development points awarded for vendor certifications"
      ]
    },
    {
      title: "Chief Technology Officer, GDevs Ltd",
      period: "July 2020 to date",
      details: ["Manage the technology required for the SigOn product (https://gdevs.co.uk/sigon)"]
    },
    {
      title: "Senior Trainer, ROI Training",
      period: "November 2018 to date",
      details: [
        "Authored, customized and delivered training across Google Cloud (Data Engineering, CLoud Architecture, Application MOdernization, DevOps, Machine Learning, Network Engineering and Security Engineering), Kubernetes and Terraform, for Google to their top tier customers",
        "Currently running several courses on Generative AI, foundational, ethics and implementation strategies"
      ]
    },
    {
      title: "Founder, IDIX Consulting",
      period: "November 2018 to date",
      details: ["Holding Company for client engagements in the fields of training, data and cloud architecture consulting"]
    },
    {
      title: "Cloud Architect - BI, Opennetworks",
      period: "June 2017 to August 2018",
      details: ["Headed up Cloud Architect team"]
    },
    {
      title: "Technical Account Manager, Slipstream Data",
      period: "November 2015 to May 2017",
      details: [
        "Opening the Johannesburg Branch and manage the Cloudera partner channel",
        "Principle consultant for Wherescape, Tableau, Cloudera and Alteryx"
      ]
    },
    {
      title: "Managed Cloud Services, OpenNetworks (PTY) LTD",
      period: "July 2014 - October 2015",
      details: ["Network design and deployment", "Cloud Consulting"]
    },
    {
      title: "Key Account Manager, Internet Solutions (PTY) LTD",
      period: "January 2010 – June 2014",
      details: ["Account Executive duties on the highest tier of Clients."]
    },
    {
      title: "Founder, IDIX Consulting CC",
      period: "2003 – 2010",
      details: []
    },
    {
      title: "Solutions Architect, The Internet Solution",
      period: "2000 – 2003",
      details: []
    },
    {
      title: "Network Engineer, Hix Internet",
      period: "1999 - 1999",
      details: []
    },
    {
      title: "Research and Development Engineer, Digital Process Measurement (PTY) LTD",
      period: "1996 - 1999",
      details: []
    },
    {
      title: "Technician, Instrotech (PTY) Ltd",
      period: "1995 - 1996",
      details: []
    }
  ],
  education: {
    institution: "University of the Witwatersrand, Johannesburg, 1995-1998",
    degree: "B.Sc Electrical Engineering",
    majors: ["Data Communications", "Power Electronics and High Voltage"],
    distinctions: [
      "Engineering Graphics (80)",
      "Engineering Applied Computing (83)",
      "Mathematical Methods (84)",
      "Electrical Engineering Design (85)",
      "Electrical Engineering Laboratory (86)"
    ],
    awards: ["Merit for Electrical Engineering Laboratory"]
  },
  certifications: [
    "Google Cloud Cloud Developer - 2014",
    "Google Certified Professional - Cloud Architect - 2017",
    "Google Certified Professional - Data Engineer - 2017",
    "Google Cloud Sales Representative - 2017",
    "Tableau Desktop 10 Qualified Associate - 2017",
    "Google Certified Professional - Cloud Developer - 2017",
    "Google Certified Professional - Network Engineer - 2019",
    "Google Certified Professional - Security Engineer - 2019",
    "Google Associate Cloud Engineer - 2019",
    "Google Certified Professional - DevOps Engineer - 2020",
    "Google Certified Professional - Machine Learning Engineer - 2020",
    "Google Certified Cloud Digital Leader -2021",
    "Google Certified Professional - Database Engineer - 2024",
    "Databricks Data Engineering Associate - 2024",
    "Linux Foundation CKAD - 2022 (Expired)"
  ]
};
